<template>
  <v-list-item @click="open">
    <v-list-item-avatar><font-awesome-icon :icon="['fal', 'at']"></font-awesome-icon></v-list-item-avatar>
    <v-list-item-content>ログイン設定</v-list-item-content>
    <v-dialog v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">ログイン設定</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field required
                    v-model="form.contact.oldEmail"
                    label="現在のメールアドレス"
                    :rules="rules.email"
                    @keypress.enter.prevent="submit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="form.passwd" required
                    name="password"
                    label="パスワード" id="password"
                    type="password"
                    :rules="rules.passwd"
                    @keypress.enter.prevent="submit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field required
                    v-model="form.contact.newEmail"
                    label="新しいメールアドレス"
                    :rules="rules.email"
                    @keypress.enter.prevent="submit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p class="caption red--text text-xs-left" v-if="config.errors.auth">
                    <span>{{ config.errors.auth }}</span>
                  </p>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-btn depressed
            color="blue darken-2 white--text"
            :loading="isLoading"
            :disabled="!isValid"
            @click="submit">更新する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'auth-toolkits-login',
  data () {
    return {
      config: {
        status: {
          active: false
        },
        errors: {
          auth: ''
        }
      },
      form: {
        valid: true,
        contact: {
          newEmail: '',
          oldEmail: ''
        },
        passwd: ''
      },
      rules: {
        passwd: [
          v => !!v || '必須項目です'
        ],
        email: [
          v => !!v || '必須項目です',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || '妥当なEメールではありません'
          }
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        contact: {
          newEmail: '',
          oldEmail: ''
        },
        passwd: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$emit('close')
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        let user = this.$firebase.auth().currentUser
        let credential = this.$firebase.auth.EmailAuthProvider.credential(this.form.contact.oldEmail, this.form.passwd)
        if (user && credential) {
          user.reauthenticateAndRetrieveDataWithCredential(credential).then(() => {
            this.$set(this.config.errors, 'auth', '')
            user.updateEmail(this.form.contact.newEmail).then(() => {
              this.$set(this.config.status, 'loading', false)
              this.$router.push('/logout')
              this.close()
            }).catch((err) => {
              console.log(err)
              this.$set(this.config.status, 'loading', false)
            })
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
            if (this.$error.firebase[err.code]) {
              this.$set(this.config.errors, 'auth', this.$error.firebase[err.code])
            }
          })
        }
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    }
  }
}
</script>
